import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaNotaComponent } from "./aba-nota.component";
import { DesabilitarNotaPopUpComponent } from "./desabilitar-nota/desabilitar-nota-popup.component";

@NgModule({
    declarations: [
        AbaNotaComponent,
        DesabilitarNotaPopUpComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        AbaNotaComponent
    ]
})
export class AbaNotaModule { }